export default __webpack_public_path__ + "static/lbusd-white-logo-2-1--e91336ba4c78b729de86eda86206d7af.png";